export var RAW_MATERIAL_TRACKER_RISK_KEY = 'rawMaterialTrackerRisk';
export var RAW_MATERIAL_TRACKER_RISK_CAUSE_KEY = 'rawMaterialTrackerRiskCause';
